module.exports = "/app/themes/roboyo2021/dist/img/clock-wht.png?7810d2b5b8fb4e7f3ed96320bc3c1e10";